import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
  IconButton,
  Dialog,
  Box,
  Tooltip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Typography,
  styled,
  TableRow,
  tableCellClasses,
} from "@mui/material";
import "react-quill/dist/quill.snow.css";
import CloseIcon from "@mui/icons-material/Close";
import CustomTypography from "../../globalStyles/fonts";
import { toast } from "react-toastify";
import { overpackService } from "../../utils/services/overpackService";
import { useNavigate } from "react-router-dom";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--table-header-bg)",
    border: "none",
    padding: "6px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding: "6px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "var(--row-bg-odd)",
    border: "1px solid var(--border-color)",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "var(--row-bg-even)",
    border: "1px solid var(--border-color)",
  },
  "&:lastChild td, &:lastChild th": {
    border: 0,
  },
}));
const OverpackViewModal = ({
  data,
  open,
  onClose,
  edit = false,
  primary_color,
  onEditData,
}) => {
  const [overpack, setOverpack] = useState({});
  const [removedShipments, setRemovedShipments] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    if (data) {
      setOverpack(data);
    }
  }, [data]);

  const onUpdate = async () => {
    try {
      await overpackService.updateOverpack({
        _id: overpack._id,
        client_id: overpack.client_id,
        overpack_id: overpack.overpack.id,
        shipment_ids: removedShipments,
      });
      onEditData && onEditData();
      toast.success("Overpack edited successfully!");
      onCloseClick();
      setRemovedShipments([]);
    } catch (e) {
      // toast.error("Failed to edit Overpack.");
      console.error(e);
    }
  };

  const removeShipment = (shipment) => {
    const updatedShipments = overpack.overpack.shipments.filter(
      (s) => s.id !== shipment.id,
    );
    setRemovedShipments((prevRemovedShipments) => {
      if (!prevRemovedShipments.includes(shipment.id)) {
        return [...prevRemovedShipments, shipment.id];
      }
      return prevRemovedShipments; // Return unchanged if ID already exists
    });
    setOverpack({
      ...overpack,
      overpack: { ...overpack.overpack, shipments: updatedShipments },
    });
  };

  const onCloseClick = () => {
    setOverpack({});
    onClose();
  };

  return (
    <>
      <Dialog open={open} onClose={onCloseClick} maxWidth="md">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <DialogTitle>
            {edit ? "Update Overpack" : "Overpack Details"}
          </DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <IconButton onClick={onCloseClick}>
              <CloseIcon />
            </IconButton>
          </div>
        </div>
        <Divider style={{ marginBottom: "10px" }} />
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <CustomTypography
                color="var(--text-heading)"
                fontSize="14px"
                fontWeight={400}
              >
                Id
              </CustomTypography>
              <TextField
                type="text"
                size="small"
                margin="dense"
                placeholder="overpack Name"
                value={overpack?.overpack?.id || ""}
                fullWidth
                sx={{
                  "& .MuiInputBase-input": {
                    color: "var(--text-secondary)",
                  },
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "var(--bg-input)",
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CustomTypography
                color={"var(--text-heading)"}
                fontSize={14}
                fontWeight={400}
              >
                Carrier
              </CustomTypography>
              <TextField
                size="small"
                autoFocus
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={overpack?.overpack?.carrier || ""}
                sx={{
                  "& .MuiInputBase-input": {
                    color: "var(--text-secondary)",
                  },
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "var(--bg-input)",
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTypography
                color="var(--text-heading)"
                fontSize="14px"
                fontWeight={400}
              >
                Entry Point
              </CustomTypography>
              <TextField
                type="text"
                size="small"
                margin="dense"
                placeholder="overpack Name"
                value={overpack?.overpack?.entry_point || ""}
                fullWidth
                sx={{
                  "& .MuiInputBase-input": {
                    color: "var(--text-secondary)",
                  },
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "var(--bg-input)",
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTypography
                color="var(--text-heading)"
                fontSize="14px"
                fontWeight={400}
              >
                Exit Point
              </CustomTypography>
              <TextField
                type="text"
                size="small"
                margin="dense"
                placeholder="overpack Name"
                value={overpack?.overpack?.exit_point || ""}
                fullWidth
                sx={{
                  "& .MuiInputBase-input": {
                    color: "var(--text-secondary)",
                  },
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "var(--bg-input)",
                  },
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>Shipment</StyledTableCell>
                      <StyledTableCell>Label ID</StyledTableCell>
                      <StyledTableCell>Tracking Number</StyledTableCell>
                      {edit && <StyledTableCell>Actions</StyledTableCell>}
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {overpack?.overpack?.shipments?.map((shipment) => (
                      <StyledTableRow key={shipment.id}>
                        <StyledTableCell>
                          <Typography
                            onClick={() => {
                              localStorage.setItem(
                                "shipment-filter-data",
                                JSON.stringify({
                                  filters: [
                                    {
                                      key: "shipment",
                                      values: [shipment.id],
                                    },
                                  ],
                                }),
                              );
                              navigate(`/shipments?child=true`);
                            }}
                            sx={{
                              textDecoration: "underline",
                              color: "blue",
                              cursor: "pointer",
                            }}
                          >
                            {shipment.id}
                          </Typography>
                        </StyledTableCell>
                        <StyledTableCell>{shipment.label_id}</StyledTableCell>
                        <StyledTableCell>
                          {shipment.tracking_number}
                        </StyledTableCell>
                        {edit && (
                          <StyledTableCell>
                            <Tooltip title="Remove this shipment?">
                              <IconButton
                                onClick={() => removeShipment(shipment)}
                                disabled={
                                  overpack?.overpack?.shipments.length === 1
                                }
                              >
                                <CloseIcon style={{ color: primary_color }} />
                              </IconButton>
                            </Tooltip>
                          </StyledTableCell>
                        )}
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ padding: 10 }}>
          <Button
            onClick={onCloseClick}
            variant="outlined"
            style={{ textTransform: "none" }}
          >
            Cancel
          </Button>
          {edit ? (
            <Button
              onClick={() => onUpdate()}
              variant="contained"
              style={{ textTransform: "none" }}
            >
              Update
            </Button>
          ) : (
            <></>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};
export default OverpackViewModal;
